/* eslint-disable max-len, react/jsx-no-bind, no-warning-comments */
import React, {useRef, useState} from "react";
import BuyItNowAPICLIENT from "../../modules/BuyItNowAPIClient";
import CreditCardStrip from "../../../CondensedSignupFlow/components/IconsLabels/CreditCardStrip";
import Helper from "../../../../shared/modules/Helper";
import LoadingSpinner from "../LoadingSpinner";
import PropTypes from "prop-types";
import ReCaptcha from "../../../CondensedSignupFlow/components/ReCaptcha";
import RecurlyFields from "./RecurlyFields";
import {useRecurly} from "@recurly/react-recurly";

const BillingInformationForm = ({
  contactId,
  displayed,
  error,
  firstName,
  handleDisplayErrors,
  lastName,
  productDescriptorId,
  recaptchaSiteKey,
  retailPrice
}) => {

  const formRef = useRef();
  const recurly = useRecurly();

  const [
    isLoading,
    setIsLoading
  ] = useState(false);

  // the captcha is rerendered based on this toggle, so no duplicate captcha tokens are submitted
  const [
    resetCaptcha,
    setResetCaptcha
  ] = useState(false);

  const handleSuccessResponse = (response) => {
    if (response.success) {
      window.location = response.redirect_path;
    } else {
      setIsLoading(false);
      handleDisplayErrors({"errorMessage": response.error});
      // reset captcha render on error
      setResetCaptcha(prev => !prev);
    }
  };

  const handleErrorResponse = () => {
    // reset captcha render on error
    setResetCaptcha(prev => !prev);
    setIsLoading(false);

    handleDisplayErrors({"errorMessage": "Oops! Something went wrong when saving your information. Please make sure everything looks correct and try again."});
  };

  const submitOrder = () => {
    recurly.token(formRef.current, (err, token) => {
      if (err) {
        setIsLoading(false);
        handleDisplayErrors({
          "errorMessage": err.message,
          "missingFields": err.fields
        });
      } else {
        // Get reCAPTCHA token
        const captchaToken = grecaptcha.getResponse(); // eslint-disable-line no-undef
        // Get query params for redirect
        const queryParams = window.location.search;

        const orderInfo = {
          captchaToken,
          contactId,
          productDescriptorId,
          queryParams,
          "recurlyToken": token.id
        };

        BuyItNowAPICLIENT.placeOrder(
          orderInfo,
          handleSuccessResponse,
          handleErrorResponse
        );
      }
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);

    if (contactId) {
      submitOrder();
    } else {
      handleDisplayErrors({"errorMessage": "Please enter your shipping information."});
      setIsLoading(false);
    }
  };

  return (
    <div className={displayed ? "billing-information" : "hidden"}>

      {error}

      <form ref={formRef}>
        <fieldset>
          <RecurlyFields />
          <div>
            <CreditCardStrip classes="credit-card-strip" />
          </div>
          <div className="total-container mt20 mb8">
            <div className="total">
              <p className="bold">
                Total
              </p>
              <p className="bold">
                {`$${Helper.formatPriceCents(retailPrice)}`}
              </p>
            </div>
            <div>
              <p className="small dark-grey">
                * Final invoice will include tax where applicable.
              </p>
            </div>
          </div>
          { resetCaptcha && <ReCaptcha recaptchaSiteKey={recaptchaSiteKey} />}
          { !resetCaptcha && <ReCaptcha recaptchaSiteKey={recaptchaSiteKey} />}
          <div className="action">
            <input
              data-recurly="first_name"
              hidden
              value={firstName}
            />
            <input
              data-recurly="last_name"
              hidden
              value={lastName}
            />
            <input
              data-recurly="country"
              disabled
              hidden
              value="US"
            />
            <button
              className="btn btn-primary centered"
              disabled={isLoading}
              onClick={handleSubmit}
              type="submit"
            >
              {isLoading ? <LoadingSpinner /> : "Place Order"}
            </button>
          </div>
        </fieldset>
      </form>
    </div>
  );
};


BillingInformationForm.defaultProps = {
  "contactId": null,
  "error": {},
  "firstName": "",
  "lastName": "",
  "recaptchaSiteKey": ""
};

BillingInformationForm.propTypes = {
  "contactId": PropTypes.number,
  "displayed": PropTypes.bool.isRequired,
  "error": PropTypes.object,
  "firstName": PropTypes.string,
  "handleDisplayErrors": PropTypes.func.isRequired,
  "lastName": PropTypes.string,
  "productDescriptorId": PropTypes.number.isRequired,
  "recaptchaSiteKey": PropTypes.string,
  "retailPrice": PropTypes.number.isRequired
};

export default BillingInformationForm;
